import React from 'react'
import "./Terms_conditions.css";
import Common_Banner from '../common-components/common-banner/Common_Banner';
import { Container } from 'react-bootstrap';

const Terms_conditions = () => {
  const breadcrumbs = [
    { label: "Home", link: "/gallery", isActive: false },
    { label: "SPORTS PROGRAMS", link: "", isActive: true },
  ];
  return (
    <>
      <Common_Banner
        imgSrc={"/assets/images/footer/privacy_policy/policy.png"}
        title_text="Terms & Conditions"
        breadcrumbs={breadcrumbs}
      />
      <section className='  terms-section'>
        <Container>
          <div className='card card_div'>
            <p className='intro'>
              Welcome to Ashva Sports & Fitness<br />
              By accessing or using our website, programs, or services,
              you agree to comply with and be bound by these Terms and Conditions.
              Please read them carefully before using our website or participating
              in any of our sports or fitness program.
            </p>
            <h2 className='head_div'>1. INTRODUCTION</h2>
            <div className='description_div'>
              <p className='grey_class'>
                By accessing or using our website, programs, or services,
                you agree to comply with and be bound by these Terms and Conditions.<br />
                Please read them carefully before using our website or participating
                in any of our sports or fitness programs.
              </p>
            </div>
            <h2 className='head_div'>2. ELIGIBILITY</h2>
            <div className='description_div' >
              <p className='grey_class'>Our services are open to individuals of all age groups.</p>
              <p className='grey_class'> Children under 18 must have consent from a parent or guardian.</p>
              <p className='grey_class'> Corporate participants must be registered through their company or authorized representative.</p>
            </div>

            <h2 className='head_div'>3. REGISTRATION & MEMBERSHIP</h2>
            <div className='description_div'>
              <p className='grey_class'>To join our programs, users may be required to register online or in person.<br /> By registering:</p>
              <p className='grey_class'> You agree to provide accurate and updated information. </p>
              <p className='grey_class'> Memberships and registrations are non-transferable.</p>
              <p className='grey_class'> We reserve the right to approve or deny registrations based on availability or eligibility.</p>
            </div >
            <h2 className='head_div'>4. PAYMENT AND SECURITY</h2>
            <div className='description_div'>
              <p className='grey_class' >All payments for programs, memberships, or events must be made in advance.</p>
              <p className='grey_class'> Refunds are applicable only if the program is canceled by [Your Brand Name].</p>
              <p className='grey_class'> No refunds will be provided for missed sessions, personal cancellations, or early withdrawals.</p>
              <p className='grey_class'> Special event or tournament fees are non-refundable once confirmed.</p>
            </div>
            <h2 className='head_div'>5. PAYMENT & REFUND POLICY</h2>
            <div className='description_div'>
              <p className='grey_class'>We use cookies and similar technologies to:</p>
              <p className='grey_class'>Remember your preferences and improve your browsing experience </p>
              <p className='grey_class'>Analyze how visitors interact with our site to enhance performance and design. .</p>
              <p className='grey_class'>Track donation trends and campaign engagement to improve services.</p>
              <p className='grey_class'> You can disable or manage cookies at any time through your browser settings. However, some parts of the website may not function properly without them.</p>
            </div>

            <h2 className='head_div'>6. CODE OF CONDUCT</h2>
            <div className='description_div'>
              <p className='grey_class'>All participants are expected to maintain discipline, sportsmanship, and respect toward coaches, staff, and other members.</p>
              <p className='grey_class'>Misbehavior, abuse, or violation of rules may result in suspension or termination of membership. </p>
              <p className='grey_class'>We promote a safe, inclusive, and positive environment for all. </p>
            </div>

            <h2 className='head_div'>7. HEALTH & SAFETY</h2>
            <div className='description_div'>
              <p className='grey_class' >Participants are responsible for ensuring they are medically fit to join any sports or fitness activity.</p>
              <p className='grey_class'>[Your Brand Name] and its trainers are not liable for injuries, accidents, or health issues arising during participation.</p>
              <p className='grey_class'>Safety guidelines and equipment provided must be used appropriately at all times.</p>
            </div>

            <h2 className='head_div'>8. INTELLECTUAL PROPERTY</h2>
            <div className='description_div'>
              <p className='grey_class' >All website content, including text, images,
                logos, and program materials, are the property of [Your Brand Name].<br />
                You may not copy, modify, or distribute any content without prior written permission.</p>
            </div>

            <h2 className='head_div'>9. PRIVACY</h2>
            <div className='description_div'>
              <p className='grey_class' >All website content, including text, images,
                logos, and program materials, are the property of [Your Brand Name].<br />
                You may not copy, modify, or distribute any content without prior written permission.</p>
            </div>

            <h2 className='head_div'>10. CHANGES TO TERMS</h2>
            <div className='description_div'>
              <p className='grey_class'>You agree not to:</p>
              <p className='grey_class'>Use the website for unlawful activities or to harm others</p>
              <p className='grey_class'>Attempt to hack, modify, or disrupt site operations</p>
              <p className='grey_class'> Upload misleading, offensive, or copyrighted material without rights.</p>
            </div>

            <h2 className='head_div'>11. LIMITATION OF LIABILITY</h2>
            <div className='description_div'>
              <p className='grey_class'>
                [Your Brand Name] reserves the right to modify these Terms & Conditions
                at any time.<br /> Updates will be posted on this page, and continued use of our
                services constitutes acceptance of the revised terms.
              </p>
            </div>

            <h2 className='head_div'>12. CONTACT US</h2>
            <div className='description_div'>
              <p className='grey_class'>
                If you have any questions or concerns regarding these Terms, please contact us:<br />
                📧 Email: [info@yourwebsite.com]<br />
                📞 Phone: +91 [Your Number] <br />
                📍 Address: [Your Sports Center / Office Location]</p>
            </div>

            {/* Buttons container */}
            {/* <div className="btn_class d-flex justify-content-center gap-2 ">
              <Decline_btn />
              <Accept_btn />
            </div> */}
          </div>
        </Container>

      </section >
    </>
  )
}

export default Terms_conditions


